import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl, getLatestMedia } from '../../common/global.js';

import styles from './PlaceList.module.scss';

export default class PlaceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onSelectPlace(placeId) {
    const ps = this.props.places.filter(p => p.id === placeId);

    if (ps && ps.length > 0) {
      const p = ps[0];

      // extract media to ease later manipulation
      const medias = p.medias || [];
      let media = p.media || { type: 'image', url: '' };
      p.media = getLatestMedia(medias, media);
      this.props.onSelectPlaceFunc(p);
    }
  }

  onClickPlace(placeId) {
    this.onSelectPlace(placeId);
  }

  onCreatePlace() {
    this.props.onCreatePlaceFunc();
  }

  onChangeText(e) {
    this.reset();
    this.props.onSearchPlaceFunc(e.target.value);
  }

  renderPlaces() {
    const { places } = this.props;
    if (isEmpty(places)) return;

    return places.map(place => {
      return this.renderPlace(place);
    });
  }

  renderPlace(place) {
    if (!place) return;
    const { id = '', name = '', address = '' } = place;
    const l = this.props.place;

    let gotToPlaceUrl = getInternalBaseUrl().places + '?id=' + id;
    let s = [styles.placeListItem];
    if (place && place.id === l.id) {
      s.push(styles.selected);
    }
    return (
      <ListItem className={s.join(' ')} key={id}>
        <div style={{ width: '100%' }}>
          <Link
            to={gotToPlaceUrl}
            style={{ textDecoration: 'none', color: 'inherit', width: '100%', padding: '10px' }}
            onClick={() => this.onClickPlace(id)}
          >
            <div className={styles.placeName}>{name}</div>
            <div>{address}</div>
          </Link>
        </div>
      </ListItem>
    );
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Place List
            <ACButton
              text={'Add'}
              icon={<AddCircleOutlineIcon key="iconAddPlace" />}
              key="btnAddPlace"
              onClickFunc={() => this.onCreatePlace()}
            />
          </div>
          <TextField
            id="simple-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Search"
            className={styles.search}
            value={this.props.searchText}
            onChange={e => this.props.onChangeSearchTextFunc(e)}
          />
        </div>
        <div className={styles.bottom}>
          <List className={styles.placeList}>{this.renderPlaces()}</List>
        </div>
      </div>
    );
  }
}
